import { ChangeDetectorRef, Component, OnInit, ViewChild, HostBinding, TemplateRef, ViewEncapsulation, Input, ElementRef, AfterViewInit, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import * as _ from 'underscore';
import { GenericColDef } from '../../models/grid-context';
import { CommonService } from '../../services/common/common.service';
import { RestService } from '../../services/rest/rest.service';
import { DocumentListComponent } from '../document-list/document-list.component';
import { DrDocument } from '../../models/dr-document';
import { GenericTreeNode } from '../generic-tree/generic-tree-node';
import { Endpoint, HelpIndex, MessageType } from '../../models/enums';
import { areArraysOfObjectsEqual, isUndefined, kFormatter } from '../../models/utils';
import { formatDate } from 'ngx-bootstrap/chronos';
import { ObjectActionListType, Permissions } from '../../models/permission';
import { Comparison } from '../../models/comparison';
import { Corpus } from '../../models/corpus';
import { interval, Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';
@Component({
    standalone: false,
    selector: 'res-matrix',
    templateUrl: './matrix.component.html',
    styleUrls: ['./matrix.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MatrixComponent implements OnInit, OnDestroy, AfterViewInit {
    @HostBinding('class') classes = 'maximized-component';
    @ViewChild('headerTemplate', { static: true }) headerTemplate: TemplateRef<any>;
    @ViewChild('downloadLink', { read: ElementRef, static: true }) downloadLink: ElementRef;
    @ViewChild('matrixGrid', { static: true }) matrixGrid: DocumentListComponent;
    @ViewChildren('allFromData') fromData: QueryList<any>;

    @Input() automationId = 'matrix-component';
    columnDefs: Array<GenericColDef>;
    isTop50: boolean;
    sortType = 'COUNT';
    matrixComponent = true;
    helpIndex: any;
    data = {
        to: [],
        toTotal: [],
        fromTotal: [],
        from: [],
        values: [],
        rawValues: [],
        columns: []
    };
    isHeaderClicked = false;
    isBusy = false;
    isBusyMessage: string;
    viewScroll: boolean;
    reportInProgress: boolean;
    reportGenerationInProgress: boolean;
    oldestReportDate: string;
    hasData: boolean;
    selectedCellsCount = 0;
    totalCellsCount = 0;
    cellsSelected: Array<any> = [];
    fromHeadersSelected: Array<any> = [];
    toHeadersSelected: Array<any> = [];
    getReportPoller: any;
    private generateDocListEvent: Subscription;
    private undoLastSelectionEvent: Subscription;
    cellSelectionReportGenerationInProgress: boolean;
    generatedReportSelectedCells: Array<any> = [];
    generatedReportSelectedToHeader: Array<any> = [];
    generatedReportSelectedFromHeader: Array<any> = [];
    dataToDisplay = true;
    selectedTab: any;

    // permissions
    hasGenerateReportVisiblePermissions = Permissions.checkUserPermission(ObjectActionListType.DOCUMENT_REPORTS);

    constructor(public changeDetector: ChangeDetectorRef, private commonService: CommonService, private restService: RestService) {
        this.generateDocListEvent = this.commonService.getMessage(MessageType.generateDocList).subscribe((data) => {
            if (data) {
                this.generateReportList();
            }
        });
        this.undoLastSelectionEvent = this.commonService.getMessage(MessageType.undoLastSelection).subscribe((data) => {
            if (data) {
                this.undoLastGridSelection();
            }
        });
        this.hasData = false;
    }

    selectedNode: GenericTreeNode;
    get selectedNodeData(): any {
        return this.selectedNode.data;
    }

    loadDataFinishedCallback = () => {
        this.cellSelectionReportGenerationInProgress = false;
        this.isBusy = this.reportInProgress ? this.reportInProgress : false;
        this.commonService.suppressGridSpinner = false;
        this.matrixGrid.isMatrixGridSelection = this.cellsSelected?.length > 0 && (this.generatedReportSelectedCells?.length === 0 && this.generatedReportSelectedFromHeader?.length === 0 &&
            this.generatedReportSelectedToHeader?.length === 0);
    }

    reselectState() {
        if (this.data?.to?.length > 0 && this.data?.from?.length > 0) {
            if (this.commonService.matrixGridsSelection?.isDocViewerOpened) {
                this.reselectCells(this.commonService.matrixGridsSelection?.generatedReportSelectedCells, 'cells');
                this.reselectCells(this.commonService.matrixGridsSelection?.generatedReportSelectedToHeader, 'toHeader');
                this.reselectCells(this.commonService.matrixGridsSelection?.generatedReportSelectedFromHeader, 'fromHeader');
                this.calculateTotalSelectedCellsEmails();
                this.generateReportList();
                this.commonService.matrixGridsSelection.isDocViewerOpened = false;
            }
        }
        else {
            setTimeout(() => {
                this.reselectState();
            }, 1000);
        }
    }

    reselectCells(cells, type): void {
        if (type === 'cells') {
            cells?.forEach((element) => {
                element = document.getElementById(element?.id);
                if (element?.className.indexOf('bg-blue') === -1) {
                    element?.classList?.add('bg-blue');
                }
                this.cellsSelected.push(element);
            });
        }
        if (type === 'toHeader') {
            cells?.forEach((element) => {
                element = document.getElementById(element.id);
                if (element?.className.indexOf('bg-blue') === -1) {
                    element?.classList?.add('bg-blue');
                }
                this.toHeadersSelected.push(element);
            });
        }

        if (type === 'fromHeader') {
            cells?.forEach((element) => {
                element = document.getElementById(element.id);
                if (element?.children[0].className.indexOf('bg-blue') === -1) {
                    element?.children[0]?.classList?.add('bg-blue');
                }
                this.fromHeadersSelected.push(element);
            });
        }

        this.generatedReportSelectedCells = Array.from(this.cellsSelected);
        this.generatedReportSelectedToHeader = Array.from(this.toHeadersSelected);
        this.generatedReportSelectedFromHeader = Array.from(this.fromHeadersSelected);
    }

    setSortType(type: string): void {
        if (type && type !== this.sortType) {
            setTimeout(() => {
                this.deselectAllCells();
                this.commonService.matrixGridsSelection.sortType = type;
                this.sortType = type;
                this.commonService.matrixGridsSelection.generatedReportSelectedCells = [];
                this.commonService.matrixGridsSelection.generatedReportSelectedToHeader = [];
                this.commonService.matrixGridsSelection.generatedReportSelectedFromHeader = [];
                this.setIsBusy(true);
                this.reportInProgress = true;
                this.loadData(this.selectedNode, true);
            });
        }
    }

    ngOnInit(): void {
        this.isTop50 = true;
    }

    selectedTreeItemChanged = (node: GenericTreeNode) => {
        this.selectedTab = this.commonService.selectedNavigationNode?.navigationInfo?.selectedTab ? this.commonService.selectedNavigationNode?.navigationInfo?.selectedTab : this.commonService.matrixGridsSelection?.selectedTab;
        this.hasData = false;
        this.selectedCellsCount = 0;
        this.cellsSelected = [], this.generatedReportSelectedCells = [], this.generatedReportSelectedFromHeader = [], this.generatedReportSelectedToHeader = [],
            this.toHeadersSelected = [], this.fromHeadersSelected = [];
        this.selectedNode = node;
        if (this.matrixGrid) {
            this.commonService.suppressGridSpinner = true;
            this.matrixGrid.selectedTreeItemChanged(node);
        }

        if (this.commonService.matrixGridsSelection?.selectedTab?.name === this.commonService.selectedNavigationNode?.navigationInfo?.selectedTab?.name
            && this.commonService.matrixGridsSelection?.selectedNode?.name === this.commonService.selectedNavigationNode?.name) {
            this.sortType = this.sortType !== this.commonService.matrixGridsSelection?.sortType ? this.commonService.matrixGridsSelection?.sortType : this.sortType;
            this.loadData(this.selectedNode);
        } else if (!this.commonService.matrixGridsSelection?.isDocViewerOpened) {
            this.sortType = 'COUNT';
            this.commonService.matrixGridsSelection.sortType = this.sortType;
            this.commonService.matrixGridsSelection.generatedReportSelectedCells = [];
            this.commonService.matrixGridsSelection.generatedReportSelectedToHeader = [];
            this.commonService.matrixGridsSelection.generatedReportSelectedFromHeader = [];
            this.loadData(this.selectedNode);
        } else {
            this.sortType = this.sortType !== this.commonService.matrixGridsSelection?.sortType ? this.commonService.matrixGridsSelection?.sortType : this.sortType;
            this.loadData(this.selectedNode);
        }
        this.commonService.matrixGridsSelection.selectedTab = this.commonService.selectedNavigationNode?.navigationInfo?.selectedTab;
        this.commonService.matrixGridsSelection.selectedNode = this.commonService.selectedNavigationNode;
    }

    checkTodayDate = (date) => {
        const today = new Date();
        const dateFormatted = new Date(date);
        const diff = (today.getTime() - dateFormatted.getTime()) / 1000 / 3600;

        if (Math.abs(Math.round(diff)) <= 24) {
            return 'Today ' + date.slice(-8);
        }

        if ((Math.abs(Math.round(diff)) > 24 && Math.abs(Math.round(diff)) < 48)) {
            return 'Yesterday ' + date.slice(-8);
        }
        return date;
    };

    setIsBusy(isLoading): void {
        this.isBusy = true;
        this.isBusyMessage = isLoading ? 'Loading ' + this.selectedTab?.name + ' ...' : 'Updating ' + this.selectedTab?.name + ' ...';
    }

    loadData(node: GenericTreeNode, withoutIsBusy = false): void {
        this.selectedCellsCount = 0;
        this.totalCellsCount = 0;
        const tab = this.selectedTab?.name === 'Communication Grid' ? 'EMAIL_COMMUNICATION' : 'DOMAIN_COMMUNICATION';
        if (!withoutIsBusy) {
            this.setIsBusy(true);
            this.reportInProgress = true;
            this.matrixGrid.isMatrixGridSelection = this.cellsSelected.length > 0;
        }
        const request = {
            viewHandle: this.getHandle(node),
            reportRequests: [{ reportType: tab, sortBy: this.sortType, defaultLimit: true }]
        }
        this.restService.post(Endpoint.viewManager_getReport, request).then(response => {
            if (response && response.reports) {
                if (response.taskHandle || response.reports.length > 1) {
                    if (!this.getReportPoller) {
                        this.startReportsPoller(request);
                    }
                } else {
                    this.stopReportsPoller();
                    if (!response.reports) {
                        this.restService.post(Endpoint.viewManager_getReport, request).then(delayedResponse => {
                            this.processFinalReportData(delayedResponse.reports);
                        });
                    } else {
                        this.processFinalReportData(response.reports);
                    }
                }
            }
        }, error => {
            this.isBusy = false;
            this.reportInProgress = false;
            this.dataToDisplay = false;
            this.stopReportsPoller();
        });

        if (this.matrixGrid) {
            this.matrixGrid.helpIndex = null;
        }
    }

    processFinalReportData(reports: any): void {
        if (reports[0]) {
            this.data = {
                to: [],
                toTotal: [],
                fromTotal: [],
                from: [],
                values: [],
                rawValues: [],
                columns: []
            };
            const convertedDates = [];
            if (reports[0].dateUpdated && reports[0].dateUpdated !== '') {
                // get the correct format for date
                const datetime = reports[0].dateUpdated.split('-');
                const convertedDate = new Date(datetime[0] + '-' + datetime[1] + '-' + datetime[2] + 'T' + datetime[3] + ':' + datetime[4] + ':' + datetime[5] + 'Z');
                convertedDates.push(convertedDate);
            }
            this.oldestReportDate = convertedDates.length > 0 ? this.checkTodayDate(formatDate(new Date(Math.min.apply(null, convertedDates)), 'YYYY-MM-DD HH:mm:ss', null, false)) : ' ';
            const report = reports[0];
            const fromCount = [];
            const toCount = [];
            Object.values(report?.fromCount).forEach((fieldValue: number) => {
                fromCount.push(kFormatter(fieldValue));
                this.totalCellsCount += fieldValue;
            });
            Object.values(report?.toCount).forEach((fieldValue: number) => {
                toCount.push(kFormatter(fieldValue));
                this.totalCellsCount += fieldValue;
            });
            const from = Object.keys(report?.fromCount);
            const fromTotal = fromCount;
            const toTotal = toCount;
            const to = Object.keys(report?.toCount);
            const values = [];
            const columns = [];
            const rawValues = [];

            to.forEach((element, index) => {
                const toAddress = report?.reportEntryList.filter((el) => {
                    const address = el.name.split("|");
                    return address[1] === element;
                });
                if (toAddress.length > 0) {
                    const row = [];
                    const data = [];
                    row.push(to[index]);
                    data.push(to[index]);
                    toAddress.forEach((address) => {
                        row.push(address.count === '0' ? '' : kFormatter(address.count, 1));
                        data.push(address.count);
                    });
                    values.push(row);
                    rawValues.push(data);
                }
            });

            Object.assign(columns, from);
            columns.unshift('');

            this.data = {
                to: to,
                toTotal: toTotal,
                fromTotal: fromTotal,
                from: from,
                values: values,
                rawValues: rawValues,
                columns: columns
            };

            this.dataToDisplay = this.data.values.length > 0;

            setTimeout(() => {
                this.highlightBetweenCommCells();
                this.viewScroll = this.checkScroll();
                this.reportInProgress = false;
                this.hasData = this.data.values.length > 0;
                this.isBusy = false;
            });
        } else {
            this.isBusy = false;
            this.reportInProgress = false;
            this.dataToDisplay = true;
        }
    }

    ngAfterViewInit() {
        this.fromData.changes.subscribe(t => {
            this.hasData = this.data.values.length > 0;
            this.isBusy = this.reportInProgress;
            this.changeDetector.detectChanges();
            this.bindHeaderMouseEvents();
            this.highlightBetweenCommCells();
        })
    }

    highlightBetweenCommCells(): void {
        const allToNodes: Element[] = Array.from(document.getElementsByClassName("address-format-to"));
        const allFromNodes: Element[] = Array.from(document.getElementsByClassName("address-format-from"));
        allToNodes.forEach((toNode: any, toIndex) => {
            allFromNodes.forEach((fromNode: any, fromIndex) => {
                if (toNode?.title === fromNode?.children[0]?.title) {
                    const dataNodes: any = Array.from(document.getElementsByClassName("from-address")[fromIndex].getElementsByClassName("data-cells"));
                    if (dataNodes) {
                        dataNodes[toIndex]?.classList?.add('default-cells-gray');
                    }
                }
                if (fromIndex === (allFromNodes.length - 1) && toIndex === (allToNodes.length - 1)) {
                    if (this.commonService.matrixGridsSelection?.isDocViewerOpened) {
                        if (this.commonService.matrixGridsSelection?.generatedReportSelectedCells?.length > 0 ||
                            this.commonService.matrixGridsSelection?.generatedReportSelectedToHeader?.length > 0 ||
                            this.commonService.matrixGridsSelection?.generatedReportSelectedFromHeader?.length > 0) {
                            this.reselectState();
                        } else {
                            this.commonService.matrixGridsSelection.isDocViewerOpened = false;
                        }
                    }
                }
            });
        });
    }

    // 5 seconds for 1 million or less docs, 15 seconds for 1 to 5 million docs, 30 seconds for higher
    startReportsPoller(request: any): void {
        let pollInterval = 5000; // 5 sec
        if (this.selectedNode && this.selectedNode.data && this.selectedNode.data.documentCount > 1000000) {
            pollInterval = this.selectedNode.data.documentCount > 5000000 ? 30000 : 15000;
        }
        this.getReportPoller = interval(pollInterval).pipe(
            startWith(0)
        ).subscribe(() => this.loadData(this.selectedNode, true));
    }

    stopReportsPoller(): void {
        if (this.getReportPoller) {
            this.getReportPoller.unsubscribe();
            this.getReportPoller = null;
        }
    }

    getHandle(node: GenericTreeNode): string {
        let handle = '';
        if (node?.data instanceof Corpus) {
            handle = node.data?.corpusViewHandle;
        } else if (node?.data instanceof Comparison) {
            const comparisonView = _.filter(node.data, (viewItem) => viewItem && viewItem.handle === node.data?.docListHandle);
            if (comparisonView && comparisonView.length > 0) {
                handle = comparisonView[0]?.handle;
            }
        } else {
            handle = node?.data?.view ? node?.data?.view?.handle : node?.data?.handle;
        }
        return handle;
    }

    updateReport(): void {
        this.deselectAllCells();
        this.setIsBusy(false);
        this.restService.post(Endpoint.viewManager_invalidateReportCache, { viewHandles: [this.getHandle(this.selectedNode)] }).then(response => {
            if (response) {
                this.loadData(this.selectedNode, true);
            }
        }, error => {
            this.isBusy = false;
        });
    }

    generateReport(): void {
        this.reportGenerationInProgress = true;
        const tab = this.selectedTab.name === 'Communication Grid' ? 'EMAIL_COMMUNICATION' : 'DOMAIN_COMMUNICATION';
        const params = {
            viewHandle: this.getHandle(this.selectedNode),
            projectHandle: this.commonService.contextHandle,
            reportType: tab
        };

        this.restService.post(Endpoint.projectManager_generateDownloadFromWorkbasketReport, params).then(response => {
            this.reportGenerationInProgress = false;
        }, error => {
            this.isBusy = false;
            this.reportGenerationInProgress = false;
        });
        this.commonService.openInformationToastNotification('Generation of the ' + this.selectedTab.name + ' Report has started. Once finished, the report can be downloaded from the Work Basket.');
    }

    calculateTotalSelectedCellsEmails(): void {
        this.selectedCellsCount = 0;
        this.cellsSelected?.forEach((element) => {
            if (element?.firstElementChild) {
                this.selectedCellsCount += parseInt(element?.firstElementChild?.attributes['raw-data-value']?.value);
            }
        });
    }

    deselectAllCells(event?: any): void {
        this.selectedCellsCount = 0;
        this.cellsSelected?.forEach((element) => {
            element?.classList.remove('bg-blue');
            if (element.className?.indexOf('row-cells-blue') !== -1) {
                element.classList?.remove('row-cells-blue');
            }
        });
        this.fromHeadersSelected?.forEach((element) => {
            element?.children[0]?.classList.remove('bg-blue');
        });
        this.toHeadersSelected?.forEach((element) => {
            element?.classList.remove('bg-blue');
        });

        this.generatedReportSelectedCells?.forEach((element) => {
            element?.classList?.remove('bg-blue');
        });
        this.generatedReportSelectedFromHeader?.forEach((element) => {
            element?.children[0]?.classList?.remove('bg-blue');
        });

        this.generatedReportSelectedToHeader?.forEach((element) => {
            element?.classList?.remove('bg-blue');
        });

        this.cellsSelected = [], this.generatedReportSelectedCells = [], this.generatedReportSelectedFromHeader = [], this.generatedReportSelectedToHeader = [],
            this.toHeadersSelected = [], this.fromHeadersSelected = [];
        this.matrixGrid.isMatrixGridSelection = this.cellsSelected.length > 0;
        this.commonService.matrixGridsSelection.viewHandle = null;
        this.commonService.matrixGridsSelection.viewName = null;

        if (event) {
            this.commonService.matrixGridsSelection.generatedReportSelectedCells = [];
            this.commonService.matrixGridsSelection.generatedReportSelectedToHeader = [];
            this.commonService.matrixGridsSelection.generatedReportSelectedFromHeader = [];
        }

        this.matrixGrid.selectedTreeItemChanged(this.selectedNode);
    }

    cellClick(from: string, fromIndex: number, index: number): void {
        index = index - 1;
        const toSelectedIndex = this.data.from.findIndex(a => a === from);
        const fromSelectedIndex = this.data.to.findIndex(a => a === this.data.from[index]);
        const nodeToHighlight = document.getElementsByClassName("from-address")[fromSelectedIndex]?.getElementsByClassName("data-cells")[toSelectedIndex];

        const currentlyClickedCell = document.getElementsByClassName("from-address")[fromIndex]?.getElementsByClassName("data-cells")[index];

        if (!this.isHeaderClicked && nodeToHighlight && nodeToHighlight?.className.indexOf('bg-blue') === -1 && currentlyClickedCell?.className.indexOf('bg-blue') !== -1) {
            nodeToHighlight?.classList.add('bg-blue');
            const nodeToHighlightAdjacentCells = Array.from(document.getElementsByClassName("from-address")[fromSelectedIndex]?.getElementsByClassName("data-cells"));
            const allAdjacentNodesSelected = [];
            nodeToHighlightAdjacentCells.forEach((element) => {
                if (element.className.indexOf('bg-blue') !== -1) {
                    allAdjacentNodesSelected.push(true);
                } else {
                    allAdjacentNodesSelected.push(false);
                    return;
                }
            });
            if (allAdjacentNodesSelected.every(item => item)) {
                const rowToAddress = document.getElementsByClassName("address-format-from")[fromSelectedIndex];
                rowToAddress.children[0].classList.add('bg-blue');
                this.isToHeaderRowSelected(fromSelectedIndex);
            }
        }

        const isCellSelected = this.cellsSelected.filter(c => c.firstElementChild === currentlyClickedCell?.firstElementChild);
        if (currentlyClickedCell?.className.indexOf('bg-blue') === -1) {
            if (nodeToHighlight) {
                this.calculateTotalSelectedCellsEmails();
            }
            this.cellsSelected = this.cellsSelected.filter(c => c.firstElementChild !== currentlyClickedCell?.firstElementChild);
            this.calculateTotalSelectedCellsEmails();
        } else {
            const highlightNodeInCellsSelected = this.cellsSelected?.filter(c => c.firstElementChild === nodeToHighlight?.firstElementChild);
            if (nodeToHighlight && nodeToHighlight !== currentlyClickedCell && highlightNodeInCellsSelected?.length === 0) {
                this.cellsSelected.push(nodeToHighlight);
            }
            if (isCellSelected.length === 0) {
                this.cellsSelected.push(currentlyClickedCell);
            }
            this.calculateTotalSelectedCellsEmails();
            this.changeDetector.detectChanges();
        }

        this.isToHeaderRowSelected(fromIndex);

        const allFromNodes: Element[] = Array.from(document.getElementsByClassName("address-format-from"));
        const verticalNodesChecked = [];
        if (allFromNodes) {
            allFromNodes.forEach((element, rowIndex) => {
                const data = Array.from(document.getElementsByClassName("from-address")[rowIndex].getElementsByClassName("data-cells"));
                if (data[index].className.indexOf('bg-blue') !== -1) {
                    verticalNodesChecked.push(true);
                } else {
                    verticalNodesChecked.push(false);
                    return;
                }
            });
        }

        const selectToHeader = document.getElementsByClassName("to-address")[index];
        if (verticalNodesChecked?.every(item => item)) {
            if (selectToHeader?.className?.indexOf('bg-blue') === -1) {
                selectToHeader.classList.add('bg-blue');
                if (!this.toHeadersSelected.includes(selectToHeader)) {
                    this.toHeadersSelected.push(selectToHeader);
                }
            }
        } else {
            if (selectToHeader?.className.indexOf('bg-blue') !== -1) {
                selectToHeader?.classList.remove('bg-blue');
                selectToHeader?.children[0].classList.remove('bg-blue');
                this.cellsSelected = this.cellsSelected.filter(c => c.firstElementChild !== selectToHeader?.firstElementChild);
                this.toHeadersSelected = this.toHeadersSelected.filter(c => c.firstElementChild !== selectToHeader?.firstElementChild);
            }
        }

        this.matrixGrid.isMatrixGridSelection = (this.cellsSelected?.length > 0 && !areArraysOfObjectsEqual(this.cellsSelected, this.generatedReportSelectedCells)) || (this.cellsSelected?.length === 0 && (this.generatedReportSelectedCells?.length > 0 || this.generatedReportSelectedFromHeader?.length > 0 || this.generatedReportSelectedToHeader?.length > 0));
    }

    private isToHeaderRowSelected(fromIndex: number) {
        const horizontalRowCellClicked = document.getElementsByClassName("address-format-from")[fromIndex];
        if (horizontalRowCellClicked) {
            const rowCells: any = Array.from(document.getElementsByClassName("from-address")[fromIndex]?.getElementsByClassName("data-cells"));

            const horizontalNodesChecked = [];
            rowCells?.forEach((element) => {
                if (element.className?.indexOf('bg-blue') !== -1) {
                    horizontalNodesChecked.push(true);
                }
            });

            if (rowCells?.length === horizontalNodesChecked.length) {
                horizontalRowCellClicked.children[0]?.classList?.add('bg-blue');
                if (!this.fromHeadersSelected?.includes(horizontalRowCellClicked)) {
                    this.fromHeadersSelected.push(horizontalRowCellClicked);
                }
            } else {
                if (horizontalRowCellClicked.children[0]?.className?.indexOf('bg-blue') !== -1) {
                    horizontalRowCellClicked.children[0]?.classList?.remove('bg-blue');
                    this.cellsSelected = this.cellsSelected?.filter(c => c?.firstElementChild !== horizontalRowCellClicked?.firstElementChild);
                    this.fromHeadersSelected = this.fromHeadersSelected?.filter(c => c?.firstElementChild !== horizontalRowCellClicked?.firstElementChild);
                }
            }
        }
    }

    fromHeaderClick(indexElement): void {
        this.isHeaderClicked = true;
        const selectedAddress = document.getElementsByClassName("address-format-from")[indexElement];
        const nodesToHighlight: Element[] = Array.from(document.getElementsByClassName("from-address")[indexElement].getElementsByClassName("data-cells"));

        if (!this.fromHeadersSelected.includes(selectedAddress) && selectedAddress?.children[0]?.className.indexOf('bg-blue') !== -1) {
            this.fromHeadersSelected.push(selectedAddress);
        } else if (selectedAddress?.children[0]?.className.indexOf('bg-blue') === -1) {
            this.fromHeadersSelected = this.fromHeadersSelected.filter(c => c.firstElementChild !== selectedAddress?.firstElementChild);
        }

        nodesToHighlight.forEach((element, index) => {
            if (selectedAddress?.children[0]?.className.indexOf('bg-blue') !== -1) {
                element.classList?.add('bg-blue');
                element.classList?.add('row-cells-blue');
                const isCellAdded = this.cellsSelected.find(c => c.firstElementChild === element?.firstElementChild);
                if (!isCellAdded) {
                    this.cellsSelected.push(element);
                    this.calculateTotalSelectedCellsEmails();
                }
            } else {
                element.classList?.remove('bg-blue')
                element.classList.add('row-cells-gray');
                if (element.className?.indexOf('row-cells-blue') !== -1) {
                    element.classList?.remove('row-cells-blue');
                }
                const isCellDeselect = this.cellsSelected.find(c => c.firstElementChild === element?.firstElementChild);
                if (isCellDeselect) {
                    this.calculateTotalSelectedCellsEmails();
                    this.cellsSelected = this.cellsSelected.filter(c => c.firstElementChild !== element?.firstElementChild);
                    this.calculateTotalSelectedCellsEmails();
                }
            }
        });

        const verticalRows = Array.from(document.getElementsByClassName("address-format-to"));
        const allFromNodes: Element[] = Array.from(document.getElementsByClassName("address-format-from"));

        verticalRows.forEach((element, nodeIndex) => {
            const verticalNodesChecked = [];
            allFromNodes.forEach((node, fromIndex) => {
                const dataNodes: any = Array.from(document.getElementsByClassName("from-address")[fromIndex].getElementsByClassName("data-cells"));

                if (dataNodes[nodeIndex]?.className?.indexOf('bg-blue') !== -1) {
                    verticalNodesChecked.push(true);
                } else {
                    verticalNodesChecked.push(false);
                    return;
                }
            });

            const selectToHeader = document.getElementsByClassName("to-address")[nodeIndex];
            if (verticalNodesChecked?.every(item => item)) {
                if (selectedAddress?.className?.indexOf('bg-blue') === -1) {
                    const addressToSelect = document.getElementsByClassName("from-address")[indexElement].getElementsByClassName("data-cells")[nodeIndex];
                    if (addressToSelect && addressToSelect.className?.indexOf('bg-blue') === -1) {
                        addressToSelect.classList.add('bg-blue');
                    }
                }

                if (selectToHeader?.className.indexOf('bg-blue') === -1) {
                    selectToHeader.classList.add('bg-blue');
                    if (!this.toHeadersSelected.includes(selectToHeader)) {
                        this.toHeadersSelected.push(selectToHeader);
                    }
                }
            } else {
                if (selectedAddress?.children[0]?.className.indexOf('bg-blue') === -1) {
                    selectToHeader?.classList.remove('bg-blue');
                    selectToHeader?.children[0].classList.remove('bg-blue');
                    this.cellsSelected = this.cellsSelected.filter(c => c.firstElementChild !== selectToHeader?.firstElementChild);
                    this.toHeadersSelected = this.toHeadersSelected.filter(c => c.firstElementChild !== selectToHeader?.firstElementChild);
                }
            }
            this.isHeaderClicked = false;
        });

        this.matrixGrid.isMatrixGridSelection = this.generatedReportSelectedCells?.length !== this.cellsSelected.length || !areArraysOfObjectsEqual(this.fromHeadersSelected, this.generatedReportSelectedFromHeader) || !areArraysOfObjectsEqual(this.toHeadersSelected, this.generatedReportSelectedToHeader);
    }

    toHeaderClick(selectedIndex): void {
        this.isHeaderClicked = true;
        const selectedAddress = document.getElementsByClassName("to-address")[selectedIndex];
        const allFromNodes: Element[] = Array.from(document.getElementsByClassName("from-address"));

        if (!this.toHeadersSelected.includes(selectedAddress) && selectedAddress?.className.indexOf('bg-blue') !== -1) {
            this.toHeadersSelected.push(selectedAddress);
        } else if (selectedAddress?.className.indexOf('bg-blue') === -1) {
            this.toHeadersSelected = this.toHeadersSelected.filter(c => c.firstElementChild !== selectedAddress?.firstElementChild);
        }

        allFromNodes.forEach((element, index) => {
            const rowDataCells: Element[] = Array.from(document.getElementsByClassName("from-address")[index].getElementsByClassName("data-cells"));

            for (let i = 0; i < rowDataCells.length; i++) {
                if (i === selectedIndex) {
                    if (selectedAddress?.className?.indexOf('bg-blue') !== -1) {
                        rowDataCells[i].classList.add('bg-blue');
                        rowDataCells[i].classList.add('row-cells-blue');

                        const isCellAdded = this.cellsSelected.find(c => c.firstElementChild === rowDataCells[i]?.firstElementChild);
                        if (!isCellAdded) {
                            this.cellsSelected.push(rowDataCells[i]);
                            this.calculateTotalSelectedCellsEmails();
                        }
                    } else {
                        rowDataCells[i].classList.remove('bg-blue');
                        if (rowDataCells[i]?.className?.indexOf('row-cells-blue') !== -1) {
                            rowDataCells[i].classList.remove('row-cells-blue')
                        }
                        rowDataCells[i]?.classList.add('row-cells-gray');

                        const isCellDeselect = this.cellsSelected.find(c => c.firstElementChild === rowDataCells[i]?.firstElementChild);
                        if (isCellDeselect) {
                            this.calculateTotalSelectedCellsEmails();
                            this.cellsSelected = this.cellsSelected.filter(c => c.firstElementChild !== rowDataCells[i]?.firstElementChild);
                            this.calculateTotalSelectedCellsEmails();
                        }
                    }

                    const selectedRowItems = [];
                    const fromAddress = document.getElementsByClassName("address-format-from")[index].children[0];
                    for (let j = 0; j < rowDataCells.length; j++) {
                        selectedRowItems.push(rowDataCells[j].className.indexOf('bg-blue') === -1 ? false : true);
                    }
                    if (selectedRowItems.some(item => !item)) {
                        fromAddress.classList.remove('bg-blue');
                        this.fromHeadersSelected = this.fromHeadersSelected.filter(c => c.firstElementChild !== fromAddress?.firstElementChild);
                    }
                    if (selectedRowItems.every(item => item)) {
                        fromAddress.classList.add('bg-blue');
                        if (!this.fromHeadersSelected.includes(document.getElementsByClassName("address-format-from")[index])) {
                            this.fromHeadersSelected.push(document.getElementsByClassName("address-format-from")[index]);
                        }
                    }
                }
            }
        });
        this.isHeaderClicked = false;
        this.matrixGrid.isMatrixGridSelection = this.generatedReportSelectedCells?.length !== this.cellsSelected.length || !areArraysOfObjectsEqual(this.fromHeadersSelected, this.generatedReportSelectedFromHeader) || !areArraysOfObjectsEqual(this.toHeadersSelected, this.generatedReportSelectedToHeader);
    }

    headersHaveSameCellsSelected(selected, generated): any {
        if (selected.length !== generated.length) {
            return false; // Arrays have different lengths, not the same objects
        }

        return selected.every(obj => generated.includes(obj));
    }

    cellMouseOver(fromAddress, fromIndex): void {
        const toSelectedIndex = this.data.from.findIndex(a => a === fromAddress);
        const fromSelectedIndex = this.data.to.findIndex(a => a === this.data.from[fromIndex - 1]);
        if (fromSelectedIndex !== -1) {
            const nodeToHighlight = document.getElementsByClassName("from-address")[fromSelectedIndex].getElementsByClassName("data-cells")[toSelectedIndex];

            if (nodeToHighlight && nodeToHighlight?.className?.indexOf('bg-grey') === -1) {
                nodeToHighlight.classList.add('bg-grey');
            }
        }
    }

    cellMouseOut(fromAddress, fromIndex): void {
        const toSelectedIndex = this.data.from.findIndex(a => a === fromAddress);
        const fromSelectedIndex = this.data.to.findIndex(a => a === this.data.from[fromIndex - 1]);

        if (fromSelectedIndex !== -1) {
            const nodeToHighlight = document.getElementsByClassName("from-address")[fromSelectedIndex].getElementsByClassName("data-cells")[toSelectedIndex];

            if (nodeToHighlight && nodeToHighlight?.className?.indexOf('bg-grey') !== -1) {
                nodeToHighlight.classList.remove('bg-grey');
            }
        }
    }

    fromMouseOver(index): void {
        const selectedAddress = document.getElementsByClassName("address-format-from")[index];
        const nodesToHighlight: Element[] = Array.from(document.getElementsByClassName("from-address")[index].getElementsByClassName("data-cells"));
        nodesToHighlight.forEach((element, index) => {
            if (selectedAddress?.children[0].className?.indexOf('bg-blue') !== -1) {
                element.classList.add('row-cells-blue');
            } else if (selectedAddress?.children[0].className?.indexOf('bg-grey') === -1 && element.className?.indexOf('bg-blue') === -1) {
                element.classList.add('row-cells-gray');
            }
        });
    }

    fromMouseOut(index): void {
        const selectedAddress = document.getElementsByClassName("address-format-from")[index];
        const nodesToHighlight: Element[] = Array.from(document.getElementsByClassName("from-address")[index].getElementsByClassName("data-cells"));
        nodesToHighlight.forEach((element, index) => {
            if (selectedAddress?.children[0].className?.indexOf('bg-grey') === -1) {
                element.classList.remove('row-cells-gray');
            }
            if (selectedAddress?.children[0].className?.indexOf('bg-blue') !== -1) {
                element.classList.remove('row-cells-blue');
            }
        });
    }

    toMouseOver(headerIndex): void {
        const selectedAddress = document.getElementsByClassName("to-address")[headerIndex];

        let i = 0;
        const len = this.data.to.length;
        while (i < len) {
            const index = i;
            const rowDataCells: Element[] = Array.from(document.getElementsByClassName("from-address")[index]?.getElementsByClassName("data-cells"));
            const rowHasSameIndex = rowDataCells.filter(function (element, rowIndex) {
                if (rowIndex === headerIndex) {
                    return true;
                }
            });
            if (rowHasSameIndex) {
                if (selectedAddress?.className?.indexOf('to-address') !== -1 && selectedAddress?.matches(':hover')
                    && rowDataCells[headerIndex]?.className?.indexOf('row-cells-gray') === -1 && rowDataCells[headerIndex].className?.indexOf('bg-blue') === -1) {
                    rowDataCells[headerIndex].classList.add('row-cells-gray');
                }
                if (selectedAddress?.className?.indexOf('bg-blue') !== -1 && selectedAddress?.matches(':hover') && rowDataCells[headerIndex]?.className?.indexOf('row-cells-blue') === -1) {
                    rowDataCells[headerIndex].classList.add('row-cells-blue');
                }
            }
            i++;
        }
    }

    toMouseOut(headerIndex): void {
        const selectedAddress = document.getElementsByClassName("to-address")[headerIndex];
        let i = 0;
        const len = this.data.to.length;
        while (i < len) {
            const index = i;
            const rowDataCells: Element[] = Array.from(document.getElementsByClassName("from-address")[index].getElementsByClassName("data-cells"));
            const rowHasSameIndex = rowDataCells.filter(function (element, rowIndex) {
                if (rowIndex === headerIndex) {
                    return true;
                }
            });
            if (rowHasSameIndex) {
                if (selectedAddress?.className?.indexOf('to-address') !== -1) {
                    rowDataCells[headerIndex].classList.remove('row-cells-gray');
                }
                if (selectedAddress?.className?.indexOf('bg-blue') !== -1 && !selectedAddress?.matches(':hover') && rowDataCells[headerIndex]?.className?.indexOf('row-cells-blue') !== -1) {
                    rowDataCells[headerIndex].classList.remove('row-cells-blue');
                }
            }
            i++;
        }
    }

    bindHeaderMouseEvents(): void {
        let i = 0;
        const len = this.data.from.length;
        while (i < len) {
            const targetHeader = document.querySelector("#header" + i);
            if (targetHeader) {
                targetHeader.addEventListener("mouseenter", (e: any) => {
                    this.toMouseOver(parseInt(e?.currentTarget?.id?.split('header')[1]));
                });
                targetHeader.addEventListener("mouseleave", (e: any) => {
                    this.toMouseOut(parseInt(e?.currentTarget?.id?.split('header')[1]));
                });
            }
            i++;
        }
    }

    checkScroll(): boolean {
        if (document.querySelector('.matrix-container')) {
            return document.querySelector('.matrix-container').clientHeight < document.querySelector('.matrix-container').scrollHeight;
        }
    }

    openHelp = () => this.commonService.openHelp(this.selectedTab.name === 'Communication Grid' ? HelpIndex.email_comm_matrix_dlg : HelpIndex.domains_matrix_dlg);

    generateReportList(drillData?: any): void {
        this.commonService.matrixGridsSelection = [];
        this.generatedReportSelectedCells = Array.from(this.cellsSelected);
        this.generatedReportSelectedToHeader = Array.from(this.toHeadersSelected);
        this.generatedReportSelectedFromHeader = Array.from(this.fromHeadersSelected);
        this.commonService.matrixGridsSelection.selectedTab = this.commonService.selectedNavigationNode?.navigationInfo?.selectedTab;
        this.commonService.matrixGridsSelection.generatedReportSelectedCells = this.generatedReportSelectedCells.length > 0 ? this.generatedReportSelectedCells : [];
        this.commonService.matrixGridsSelection.generatedReportSelectedToHeader = this.generatedReportSelectedToHeader.length > 0 ? this.generatedReportSelectedToHeader : [];
        this.commonService.matrixGridsSelection.generatedReportSelectedFromHeader = this.generatedReportSelectedFromHeader.length > 0 ? this.generatedReportSelectedFromHeader : [];
        this.commonService.matrixGridsSelection.isDocViewerOpened = false;
        this.commonService.matrixGridsSelection.sortType = this.sortType;
        this.cellSelectionReportGenerationInProgress = true;
        let mappedSelectedCells = this.cellsSelected?.map(e => e?.id).filter(entry => entry !== "|");

        const rowEntries = [];
        this.toHeadersSelected.forEach((element, rowIndex) => {
            mappedSelectedCells = mappedSelectedCells.filter(c => c.split("|")[0]?.trim() !== element?.firstChild?.title);
            rowEntries.push(element?.firstChild?.title);
        });
        this.fromHeadersSelected.forEach((element, rowIndex) => {
            mappedSelectedCells = mappedSelectedCells.filter(c => c.split("|")[1]?.trim() !== element?.firstChild?.title);
            if (element?.firstChild?.title) {
                rowEntries.push("|" + element?.firstChild?.title);
            }
        });
        const entriesToSend = rowEntries?.concat(mappedSelectedCells)?.filter(entry => entry !== "|");

        if (this.cellsSelected?.length === 0 && entriesToSend?.length === 0) {
            this.matrixGrid.selectedTreeItemChanged(this.selectedNode);
        } else {
            this.isBusy = true;
            this.isBusyMessage = 'Generating Document List ...';

            const request = {
                entryNameList: entriesToSend,
                hideSearchWb: false,
                reportType: this.selectedTab?.name === 'Communication Grid' ? 'EMAIL_COMMUNICATION' : 'DOMAIN_COMMUNICATION',
                searchDialect: this.commonService.searchDialect,
                viewHandle: this.getHandle(this.selectedNode)
            };

            this.restService.post(Endpoint.viewManager_drillDownOnReport, request).then(response => {
                if (response && response.viewHandle) {
                    this.matrixGrid.requestInfo.data.viewHandle = response.viewHandle;
                    this.commonService.matrixGridsSelection.viewHandle = response.viewHandle;
                    this.commonService.matrixGridsSelection.viewName = response.viewName;
                    this.matrixGrid.isGeneratedComGridsDocList = true;
                    this.commonService.suppressGridSpinner = true;
                    this.matrixGrid.genericGrid.setData([]);
                    if (this.matrixGrid?.requestInfo?.data) {
                        this.matrixGrid.requestInfo.data.startIndex = 0;
                    }
                    this.matrixGrid.loadData();
                } else {
                    if (response.taskStatus && response.taskStatus === 'SUCCESS') {
                        this.generateReportList(drillData);
                    }
                }
            }, error => {
                this.cellSelectionReportGenerationInProgress = false;
                this.isBusy = false;
                this.commonService.suppressGridSpinner = false;
            });
        }
    }

    undoLastGridSelection(): void {
        const result = this.generatedReportSelectedCells?.length === 0 ? this.cellsSelected : this.cellsSelected.filter(o1 => !this.generatedReportSelectedCells?.some(o2 => o1 === o2));
        result?.forEach((element) => {
            element?.classList?.remove('bg-blue');
            this.cellsSelected = this.cellsSelected.filter(c => c.firstElementChild !== element?.firstElementChild);
        });

        for (let i = this.fromHeadersSelected.length - 1; i >= 0; i--) {
            const element = this.fromHeadersSelected[i];
            if (element?.children[0]?.classList?.contains('bg-blue')) {
                element?.children[0]?.classList?.remove('bg-blue');
                this.fromHeadersSelected.splice(i, 1);
            }
        }

        for (let i = this.toHeadersSelected.length - 1; i >= 0; i--) {
            const element = this.toHeadersSelected[i];
            if (element?.classList?.contains('bg-blue')) {
                element?.classList?.remove('bg-blue');
                this.toHeadersSelected.splice(i, 1);
            }
        }

        if (this.generatedReportSelectedCells?.length > 0 || this.generatedReportSelectedFromHeader?.length > 0 || this.generatedReportSelectedToHeader?.length > 0) {
            this.generatedReportSelectedCells?.forEach((element) => {
                if (element?.className?.indexOf('bg-blue') === -1) {
                    element?.classList?.add('bg-blue');

                    const isCellSelected = this.cellsSelected?.filter(c => c?.firstElementChild === element?.firstElementChild);
                    if (isCellSelected?.length === 0) {
                        this.cellsSelected?.push(element);
                    }

                    //check nodes selected horizontal for header and reselect header if all cells selected
                    this.reselectToHeader(element);

                    //check nodes selected vertically for header and reselect header if all cells selected
                    const fromHeaders = document.getElementsByClassName("to-address");
                    const headerName = element?.id?.split('|')[0];
                    for (let i = 0; i < fromHeaders?.length; i++) {
                        const domElement: any = fromHeaders[i];

                        const headerIndex = domElement?.cellIndex - 1;
                        const allToNodes: Element[] = Array.from(document.getElementsByClassName("address-format-from"));
                        const verticalNodesChecked = [];
                        if (allToNodes) {
                            allToNodes.forEach((element, rowIndex) => {
                                const data = Array.from(document.getElementsByClassName("from-address")[rowIndex].getElementsByClassName("data-cells"));
                                if (data && data[headerIndex]?.className?.indexOf('bg-blue') !== -1) {
                                    verticalNodesChecked.push(true);
                                } else {
                                    verticalNodesChecked.push(false);
                                    return;
                                }
                            });
                        }

                        const headerNode: any = document.getElementsByClassName("to-address")[headerIndex];
                        if (verticalNodesChecked?.every(item => item) && headerNode?.children[0]?.title === headerName) {
                            if (headerNode?.className?.indexOf('bg-blue') === -1) {
                                headerNode?.classList?.add('bg-blue');
                                if (!this.toHeadersSelected?.includes(headerNode)) {
                                    this.toHeadersSelected.push(headerNode);
                                    break;
                                }
                            }
                        }
                    }
                }

                //check nodes selected horizontal for header and reselect header if all cells selected
                this.reselectToHeader(element);
            });

            this.generatedReportSelectedFromHeader?.forEach((element) => {
                if (element?.children[0]?.className.indexOf('bg-blue') === -1) {
                    element?.children[0]?.classList?.add('bg-blue');
                }
            });

            this.generatedReportSelectedToHeader?.forEach((element) => {
                if (element?.className?.indexOf('bg-blue') === -1) {
                    element?.classList?.add('bg-blue');
                }
            });
        }
        this.calculateTotalSelectedCellsEmails();
        this.changeDetector.detectChanges();
        this.matrixGrid.isMatrixGridSelection = false;
    }

    private reselectToHeader(element: any) {
        const horizontalRow = element?.parentNode?.children[0];
        const rowCells: any = Array.from(element.parentNode.getElementsByClassName("data-cells"));
        const horizontalNodesChecked = [];
        rowCells?.forEach((element) => {
            if (element?.className?.indexOf('bg-blue') !== -1) {
                horizontalNodesChecked.push(true);
            }
        });

        if (rowCells.length === horizontalNodesChecked.length) {
            if (horizontalRow?.children[0]?.className?.indexOf('bg-blue') === -1) {
                horizontalRow?.children[0]?.classList?.add('bg-blue');
            }
            if (!this.fromHeadersSelected?.includes(horizontalRow)) {
                this.fromHeadersSelected?.push(horizontalRow);
            }
        }
    }

    ngOnDestroy(): void {
        this.hasData = false;
        this.stopReportsPoller();
        if (this.commonService.matrixGridsSelection) {
            this.commonService.matrixGridsSelection.viewHandle = null;
            this.commonService.matrixGridsSelection.viewName = null;
            this.commonService.matrixGridsSelection.openFromDocumentActionBtn = false;
        }
        this.generateDocListEvent.unsubscribe();
        this.undoLastSelectionEvent.unsubscribe();
    }
}